import { render, staticRenderFns } from "./SliderMain.vue?vue&type=template&id=bfd79194&"
import script from "./SliderMain.vue?vue&type=script&lang=js&"
export * from "./SliderMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports